var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.items)?_c('ul',{staticClass:"uk-child-width-1-2@s uk-grid-match homework__list uk-grid-small",attrs:{"uk-grid":""}},_vm._l((_vm.items),function(item,k){return _c('HomeworkItem',{key:k,attrs:{"date":k,"items":item}})}),1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }